import { makeStyles } from '@material-ui/core/styles'
import useServiceList from './useServiceList'

const ServiceList = ({
  admin,
  index,
  editMode,
  data,
  formikProps,
  resetToDefault,
  className,
  reorderFields,
  toggleIsHidden,
  updateFieldLabel,
  updateDataType,
  updateCardLabel,
  isCardDirty,
  layoutDefaultData
}) => {
  const classes = useStyles({ index })
  const {
    selectedChecker,
    handleChange,
    servicesCategorizedByServiceType,
    viewSwitcher
  } = useServiceList({ admin })
  return (
    <div className={`${classes.root} ${className}`}>
      {viewSwitcher({
        admin,
        selectedChecker,
        handleChange,
        servicesCategorizedByServiceType,
        index,
        editMode,
        data,
        formikProps,
        resetToDefault,
        reorderFields,
        toggleIsHidden,
        updateFieldLabel,
        updateDataType,
        updateCardLabel,
        isCardDirty,
        layoutDefaultData
      })}
    </div>
  )
}

export default ServiceList

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: 350,
    flexGrow: 2,
    '& .MuiCollapse-root': {
      maxHeight: '200px',
      overflowY: 'auto'
    },

    '& .MuiAccordionSummary-root': {
      padding: 0
    },
    '& .MuiAccordionDetails-root': {
      display: 'flex',
      flexDirection: 'column',
      paddingLeft: '27px !important',

      '& .MuiButtonBase-root': {
        textTransform: 'none',
        margin: '5px 0'
      },
      '& .MuiButton-label': {
        display: 'inline-block',
        textAlign: 'left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    }
  }
}))
